import type {
  CreateDecorLibraryItemInput,
  DecorLibraryFilter,
  DecorLibraryItem,
  DecorLibrarySuggestion,
  ReadDecorLibraryInput,
  UpdateDecorLibraryItemInput,
} from '@peles/shared';
import { apiClient } from './client';

/** The office's decor pieces passing a filter (`/decor-library`, PLANNER+). */
export async function listDecorLibrary(
  filter: DecorLibraryFilter = {},
): Promise<DecorLibraryItem[]> {
  const params: Record<string, string> = {};
  if (filter.category) params.category = filter.category;
  if (filter.q) params.q = filter.q;
  if (filter.tags?.length) params.tags = filter.tags.join(',');
  if (filter.vendorIds?.length) params.vendorIds = filter.vendorIds.join(',');
  if (filter.colors?.length) params.colors = filter.colors.join(',');
  if (filter.includeInactive) params.includeInactive = 'true';
  const { data } = await apiClient.get<DecorLibraryItem[]>('/decor-library', { params });
  return data;
}

export async function createDecorLibraryItem(
  input: CreateDecorLibraryItemInput,
): Promise<DecorLibraryItem> {
  const { data } = await apiClient.post<DecorLibraryItem>('/decor-library', input);
  return data;
}

export async function updateDecorLibraryItem(
  id: string,
  input: UpdateDecorLibraryItemInput,
): Promise<DecorLibraryItem> {
  const { data } = await apiClient.patch<DecorLibraryItem>(`/decor-library/${id}`, input);
  return data;
}

export async function deleteDecorLibraryItem(id: string): Promise<void> {
  await apiClient.delete(`/decor-library/${id}`);
}

/** What the AI reads in a piece's pictures — a suggestion, nothing saved. */
export async function readDecorLibraryPictures(
  input: ReadDecorLibraryInput,
): Promise<DecorLibrarySuggestion> {
  const { data } = await apiClient.post<DecorLibrarySuggestion>('/decor-library/read', input);
  return data;
}
